import {
    Button, Stack
} from '@mui/material'

import { useLandingZoneMigration } from '@features/hooks/LandingZones/migration'

import RequestHelp from '@views/Landingzones/Migration/Components/RequestHelp'

export const Intro = () => {
    const { handleNext } = useLandingZoneMigration()

    return (
        <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} sx={{p: 2}}>
            <RequestHelp />
            <Button onClick={handleNext}>Start migration</Button>
        </Stack>
    )
}

export default Intro